export default __webpack_public_path__ + "static/front-e6083ec817f48f8e2b98616371820fa5.jpg";